<template>
  <div class="plugin-wrapper" v-if="config && Array.isArray(config.nodes) && config.nodes.length">
    <div class="plugin-product_swiper layout animatedParent animateOnce">
      <div :class="'carousel swiper' + _uid">
        <swiper class="swiper-x-container" :ref="'MIPSwiper' + _uid" :options="swiperOpts">
          <swiper-slide class="swiper-x-item" v-for="(item, index) in config.nodes" :key="index">
            <div class="carousel-item">
              <BaseItem :source="item" />
            </div>
          </swiper-slide>
        </swiper>
        <SwiperNavigator v-if="config.nodes.length >= 3" :xSwiper="MIPSwiper" :total="config.nodes.length" />
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import BaseItem from '@/components/BaseItem';
import SwiperNavigator from '@/components/SwiperNavigator';

export default {
  name: "ProductSwiper",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  components: { swiper, swiperSlide, BaseItem, SwiperNavigator },
  data() {
    return {
      MIPSwiper: {},
      swiperOpts: {
        loop: true,
        loopedSlides: this.config.nodes.length + 2,
        speed: 1000,
        slidesPerView: 3,
        breakpoints: {
          // 768: {
          //   slidesPerView: 2,
          //   centeredSlides: false,
          //   centeredSlidesBounds: false,
          //   spaceBetween: 0
          // },
          1024: {
            slidesPerView: this.config.nodes.length > 3 ? 1.995 : 2,
            centeredSlides: this.config.nodes.length > 3 ? true : false,
            centeredSlidesBounds: this.config.nodes.length > 3 ? true : false,
            spaceBetween: 0
          }
        },
        navigation: {
          prevEl: `.swiper${this._uid} .carousel__btn--prev`,
          nextEl: `.swiper${this._uid} .carousel__btn--next`
        }
      }
    };
  },
  created() {},
  mounted() {
    this.MIPSwiper = this.$refs?.['MIPSwiper' + this._uid]?.swiper;
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
  .carousel-item { padding: 0 .5rem; }
  // 
  .plugin-wrapper {
    .plugin-product_swiper {
      .carousel {
        position: relative;
        padding: 0;
      }
    }
  }
  @media screen and (min-width: 48em) {
    .carousel-item { padding: 0 .6875rem; }
  }
  @media screen and (min-width: 64em) {
    .carousel-item { padding: 0 .5rem; }
    // 
    .plugin-wrapper {
      .plugin-product_swiper {
        .carousel {
          padding: 2.5rem 1.875rem 1.875rem;
        }
      }
    }
  }
  @media screen and (min-width: 75em) {
    .plugin-wrapper {
      .plugin-product_swiper {
        .carousel {
          padding: 0;
        }
      }
    }
  }
</style>